import { S as Swiper } from './swiper-core-PnKJBlxA.js';

class StickyLinksHeader extends HTMLElement {
  swiperInstance = null;

  connectedCallback() {
    this.blocks = this.querySelectorAll('.swiper-slide');
    this.parentSection = this.closest('section');
    this.siblingSections = this.getSiblingSections();
    this.swiper = this.querySelector('.swiper');

    this.setBlockHrefs();
    this.initSwiper();

    this.blocks.forEach((block) => {
      block.addEventListener('click', (event) => this.handleSlideChange(event, block));
    });

    this.observer = new IntersectionObserver(this.handleIntersection, {
      rootMargin: '0px 0px -100%',
      threshold: 0,
    });

    this.siblingSections.forEach((section) => this.observer.observe(section));
  }

  setBlockHrefs() {
    this.blocks.forEach((block, index) => {
      const { id } = this.siblingSections[index] || {};

      if (!id) return block.remove();

      block.href = `#${this.siblingSections[index].id}`;
    });
  }

  getSiblingSections() {
    const sections = [];
    let currentSection = this.parentSection;

    let n = 0;
    while (n < this.blocks.length) {
      n++;
      if (currentSection.nextElementSibling) {
        currentSection = currentSection.nextElementSibling;
        sections.push(currentSection);
      }
    }

    return sections;
  }

  initSwiper() {
    this.swiperInstance = new Swiper(this.swiper, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      breakpoints: {
        768: {
          spaceBetween: 32,
        },
      },
      on: {
        click: (swiper) => {
          const { clickedIndex, activeIndex } = swiper;
          this.handleSlideChange(clickedIndex, activeIndex);
        },
      },
    });
  }

  handleSlideChange(newIndex, activeIndex) {
    // Set click slide as active
    if (newIndex !== activeIndex) {
      this.swiperInstance.slideTo(newIndex);
      this.swiperInstance.activeIndex = newIndex;
      this.swiperInstance.updateSlidesClasses();
    }
  }

  handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const sectionIndex = this.siblingSections.indexOf(entry.target);
        this.handleSlideChange(sectionIndex, this.swiperInstance.activeIndex);
      }
    });
  };
}

customElements.define('sticky-links-header', StickyLinksHeader);
